module.exports = __webpack_public_path__ + "img/avatar-s-22.350e5390.png";